import { RouterProvider } from "react-router-dom";

import { router } from "@/routes";

export default function RouterDomProvider() {
  return <RouterProvider router={router} />;
}
